import { UserType } from "@/types/userType";

export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const smoothScrollToElement = (id: string) => {
  if (!id) return;
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: "smooth" });
  }
};

export const isUserProfileComplete = (user: UserType | undefined): boolean => {
  if (!user) return false;

  const requiredFields = [
    "name",
    // "email",
    "phone",
    "handle",
  ];
  return requiredFields.every(
    (field) =>
      user[field] &&
      user[field] !== "" &&
      user[field] !== undefined &&
      user?.handle !== "new_user"
  );
};
